import { useUser } from "../contexts/UserContext";
import { useScopeParams } from "./useScopeParams";
import { toBackendTrialId } from "@/utils/trialIdMap";

const useIsFeatureFlagEnabled = (): ((
  featureflag: string | string[],
) => boolean) => {
  const { userInfo } = useUser();
  const { id: rawId, scope } = useScopeParams();
  const id = toBackendTrialId(rawId);
  const thisTrial = userInfo?.available_trials?.find(
    (trial: any) => trial.id === id,
  ) as any;

  return (featureflag: string | string[]) => {
    const flags = Array.isArray(featureflag) ? featureflag : [featureflag];
    // In portfolio scope there is no single trial — check across all trials.
    if (scope === "portfolio") {
      return (
        userInfo?.available_trials?.some((trial: any) =>
          flags.some((flag) => trial.feature_flags?.includes(flag)),
        ) ?? false
      );
    }
    return flags.some((flag) => thisTrial?.feature_flags?.includes(flag));
  };
};

export default useIsFeatureFlagEnabled;
